<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 41 37"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
		<path d="M20.5204387,37 C26.8973081,37 31.8298438,35.444881 35.3180459,32.334643 C38.8062479,29.224405 40.6866068,24.921909 40.9591226,19.4271552 C41.0136258,18.8051076 41.0136258,18.1948924 40.9591226,17.5728448 C40.6866068,12.1299283 38.7789963,7.84039167 35.2362911,4.704235 C31.6935859,1.56807833 26.7883018,0 20.5204387,0 C14.1980724,0 9.26553672,1.56807833 5.72283151,4.704235 C2.18012629,7.84039167 0.272515786,12.1299283 3.55271368e-15,17.5728448 L3.55271368e-15,19.4271552 C0.272515786,24.921909 2.15287471,29.224405 5.64107677,32.334643 C9.12927883,35.444881 14.0890661,37 20.5204387,37 Z" class="bg" fill="#FF3D37"></path>
		<path d="M25,13.7122312 L23.550006,13.7132524 C22.4129257,13.7132524 22.1924419,14.2861296 22.1924419,15.1265536 L22.1924419,16.9810009 L24.9046817,16.9810009 L24.5513299,19.8862336 L22.1924419,19.8862336 L22.1924419,27 L19.3646648,27 L19.3646648,19.8862336 L17,19.8862336 L17,16.9810009 L19.3646648,16.9810009 L19.3646648,14.8396045 C19.3646648,12.3530521 20.7963654,11 22.886629,11 C23.8879528,11 24.7487062,11.0786302 25,11.1143712 L25,13.7122312 Z" fill="#000"></path>
  </svg>
</template>

<script>
export default {
  props: {
		type: {
			type: String,
			ddefault: ''
		},
    width: {
      type: Number,
      default: 41,
    },
    height: {
      type: Number,
      default: 37,
    },
    fill: {
      type: String,
      default: "#FF3D37",
    },
  },
};
</script>

<style scoped>
path {
	transition: all .3s;
}
</style>
